'use strict';

export class PubSub {
  /**
   * @private
   */
  constructor() {
    this.events = {};
  }

  publish(name, ...data) {
    let e = this.events[name];

    if (!e) {
      return;
    }
    e.forEach((fn) => fn(...data));
  }

  subscribe(name, func) {
    if (!this.events[name]) {
      this.events[name] = [];
    }

    const index = this.events[name].push(func) - 1;

    return {
      _index: index,
      name: name,
      remove: () => this.remove(name, index),
    };
  }

  remove(name, index) {
    let e = this.events[name];

    if (e && typeof index === 'undefined') {
      delete this.events[name];
      return true;
    }

    if (e && e[index]) {
      delete e[index];
      return true;
    }

    return false;
  }

  static get instance() {
    return (window['PubSub'] ??= new PubSub());
  }
}

export const pubsub = PubSub.instance;
